// extracted by mini-css-extract-plugin
module.exports = {"Ajouter":"ManageTweet_Ajouter__3c6I4","submit":"ManageTweet_submit__dVbbZ"};